import React from 'react';

/**
 * Selectores globales de proyecto e IGV para líneas de productos
 * cuando las opciones están activas en configuraciones generales.
 */
const ProductLineDefaultsBar = ({
  productsProjectEnabled,
  productsIgvEnabled,
  projects = [],
  defaultProjectId = '',
  onDefaultProjectIdChange,
  defaultHasIgv = true,
  onDefaultHasIgvChange,
  salePriceTypes = [],
  defaultSaleTypeId = '',
  onDefaultSaleTypeIdChange,
  className = 'mb-3',
}) => {
  const showSaleTypes = salePriceTypes.length > 0;

  if (!productsProjectEnabled && !productsIgvEnabled && !showSaleTypes) {
    return null;
  }

  return (
    <div
      className={`flex flex-wrap items-end gap-4 rounded-md border border-teal-200/80 bg-white/70 px-3 py-2.5 ${className}`}
    >
      <p className="w-full text-xs font-semibold uppercase tracking-wide text-teal-900 sm:mb-0 sm:w-auto">
        Por defecto en productos
      </p>
      {productsProjectEnabled && (
        <div className="min-w-[14rem] flex-1">
          <label className="mb-1 block text-xs font-medium text-gray-700">
            Proyecto por defecto
          </label>
          <select
            value={defaultProjectId || ''}
            onChange={(e) => onDefaultProjectIdChange?.(e.target.value)}
            className="w-full h-[34px] rounded-md border border-gray-300 bg-white px-2 py-1.5 text-sm focus:border-teal-500 focus:outline-none focus:ring-1 focus:ring-teal-500"
          >
            <option value="">Seleccionar proyecto</option>
            {projects.map((project) => (
              <option key={project.id} value={project.id}>
                {project.code} - {project.name}
              </option>
            ))}
          </select>
        </div>
      )}
      {productsIgvEnabled && (
        <div className="min-w-[8rem]">
          <label className="mb-1 block text-xs font-medium text-gray-700">
            IGV por defecto
          </label>
          <select
            value={defaultHasIgv ? 'true' : 'false'}
            onChange={(e) => onDefaultHasIgvChange?.(e.target.value === 'true')}
            className="w-full h-[34px] rounded-md border border-gray-300 bg-white px-2 py-1.5 text-sm focus:border-teal-500 focus:outline-none focus:ring-1 focus:ring-teal-500"
          >
            <option value="true">Sí</option>
            <option value="false">No</option>
          </select>
        </div>
      )}
      {showSaleTypes && (
        <div className="min-w-[12rem] flex-1">
          <label className="mb-1 block text-xs font-medium text-gray-700">
            Tipo de venta por defecto
          </label>
          <select
            value={defaultSaleTypeId || ''}
            onChange={(e) => onDefaultSaleTypeIdChange?.(e.target.value)}
            className="w-full h-[34px] rounded-md border border-gray-300 bg-white px-2 py-1.5 text-sm focus:border-teal-500 focus:outline-none focus:ring-1 focus:ring-teal-500"
          >
            <option value="">Seleccionar tipo</option>
            {salePriceTypes.map((type) => (
              <option key={type.id} value={type.id}>
                {type.name}
                {type.is_default ? ' (predeterminado)' : ''}
              </option>
            ))}
          </select>
        </div>
      )}
    </div>
  );
};

export default ProductLineDefaultsBar;
